import PropTypes from 'prop-types';

import LoadingLine from '../LoadingStates/LoadingLine';

/**
 * @typedef {{
 *  HtmlTag: import('react').ElementType
 *  alignItems: 'items-baseline'|'items-center'|'items-end'|'items-start'|'items-stretch'
 *  flex: boolean
 *  capitalize: boolean
 *  isLoading: boolean
 *  isLoadingScreenReaderText: string
 *  justifyContent: 'justify-around'|'justify-between'|'justify-center'|'justify-end'|'justify-evenly'|'justify-start'
 * }} Props
 * @type {import('react').FC<Props>}
 */
const TextCell = ({
  HtmlTag,
  alignItems,
  capitalize,
  children,
  flex,
  isLoading,
  isLoadingScreenReaderText,
  justifyContent,
  ...props
}) => {
  if (isLoading) {
    return (
      <div className="leading-2 mr-8" role="status">
        <span className="sr-only">{isLoadingScreenReaderText}</span>
        <LoadingLine height={6} width="70%" />
        <LoadingLine height={6} />
      </div>
    );
  }

  return (
    <HtmlTag
      {...props}
      className={`${flex ? 'flex' : ''} ${alignItems} ${justifyContent} ${
        capitalize ? 'capitalize' : ''
      }`}
    >
      {children}
    </HtmlTag>
  );
};

TextCell.defaultProps = {
  alignItems: 'items-start',
  capitalize: false,
  flex: false,
  HtmlTag: 'span',
  isLoading: false,
  isLoadingScreenReaderText: 'Loading...',
  justifyContent: 'justify-start',
};

TextCell.propTypes = {
  HtmlTag: PropTypes.string,
  alignItems: PropTypes.oneOf([
    'items-baseline',
    'items-center',
    'items-end',
    'items-start',
    'items-stretch',
  ]),
  capitalize: PropTypes.bool,
  children: PropTypes.node.isRequired,
  flex: PropTypes.bool,
  isLoading: PropTypes.bool,
  isLoadingScreenReaderText: PropTypes.string,
  justifyContent: PropTypes.oneOf([
    'justify-around',
    'justify-between',
    'justify-center',
    'justify-end',
    'justify-evenly',
    'justify-start',
  ]),
};

export default TextCell;
